import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import UnderConstruction from "../src/pages/UnderConstruction";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import { ConfigProvider } from "antd";
import CheckMail from "./pages/CheckMail";
import NewPassword from "./pages/NewPassword";
import MailVerified from "./pages/MailVerified";
import UserLock from "./pages/UserLock";
import CandidateDashboard from "./pages/candidate/CandidateDashboard";
import Settings from "./pages/Settings";
import CandidateOnboarding from "./pages/candidate/onboarding/CandidateOnboarding";
import Preparation from "./pages/candidate/preparation/Preparation";
import CreatePrepGuide from "./pages/candidate/preparation/CreatePrepGuide";
import ViewGuide from "./pages/candidate/preparation/ViewGuideMaster";
import Utils from "./utils/Utils";
import Page404 from "./pages/Page404";
import SaveDraftGuide from "./pages/candidate/preparation/SaveDraftGuide";
import Test from "./pages/candidate/test/Test";
import Insights from "./pages/candidate/insights/Insights";
import Jobs from "./pages/candidate/jobs/Jobs";
import CreditsPage from "./pages/candidate/CreditsPage";
import LearnOrPractice from "./pages/candidate/preparation/LearnOrPractice";
import Practice from "./pages/candidate/practice/Practice";
import CVOptimizer from "./pages/candidate/cv-optimizer/CVOptimizer";
import MockInterview from "./pages/candidate/mock-interview/MockInterview";
import JdCreationPage from "./pages/JdCreationPage";
import MockCreateNew from "./components/candidate/mockInterview/MockCreateNew";
import ScheduleMainPage from "./components/candidate/mockInterview/schedulePages/ScheduleMainPage";

import B2BPreparation from "./pages/b2bCandidate/preparation/Preparation";
import B2BPractice from "./pages/b2bCandidate/practice/Practice";
import B2BCVOptimizer from "./pages/b2bCandidate/cv-optimizer/CVOptimizer";
import B2BMockInterview from "./pages/b2bCandidate/mock-interview/MockInterview";
import B2BTest from "./pages/b2bCandidate/test/Test";
import B2BInsights from "./pages/b2bCandidate/insights/Insights";
import B2BJobs from "./pages/b2bCandidate/jobs/Jobs";

// TODO: Import your role-specific pages as you build them
// import StaffDashboard from "./pages/staff/StaffDashboard";
// import OrgAdminDashboard from "./pages/org-admin/OrgAdminDashboard";
// import B2BStudentDashboard from "./pages/b2b-student/B2BStudentDashboard";

import { ROLES } from "./constants/UserRoles"; // adjust path as needed
import React from "react";
import OrgAdminDashboard from "./pages/orgAdmin/OrgAdminDashboard";
import OrgAdminJobs from "./pages/orgAdmin/OrgAdminJobs";
import OrgAdminStudents from "./pages/orgAdmin/OrgAdminStudents";
import ForcePassRequired from "./pages/ForcePassRequired";
import B2BCandidateDashboard from "./pages/b2bCandidate/B2BCandidateDashboard";
import OrgAdminViewBatch from "./pages/orgAdmin/OrgAdminViewBatch";
import OrgAdminPrepGuides from "./pages/orgAdmin/OrgAdminPrepGuides";
import OrgAdminJdCreation from "./pages/orgAdmin/OrgAdminJdCreation";
import OrgAdminBulkDetails from "./pages/orgAdmin/OrgAdminBulkDetails";
import OrgAdminLearnOrPractice from "./pages/orgAdmin/OrgAdminLearnOrPractice";
import OrgAdminViewGuideMaster from "./pages/orgAdmin/OrgAdminViewGuideMaster";
import OrgAdminViewGuide from "./pages/orgAdmin/OrgAdminViewGuide";
import OrgAdminPractice from "./pages/orgAdmin/OrgAdminPractice";
import B2BCandLearnOrPractice from "./pages/b2bCandidate/preparation/LearnOrPractice";
import B2BCandViewGuide from "./pages/b2bCandidate/preparation/ViewGuideMaster";
import OrgAdminMockInterview from "./pages/orgAdmin/OrgAdminMockInterview";
import OrgAdminMockCreateNew from "./components/orgAdmin/mockInterview/OrgAdminMockCreateNew";
import OrgAdminManageInterview from "./pages/orgAdmin/OrgAdminManageInterview";
import B2BScheduleMainPage from "./components/b2bCandidate/mockInterview/schedulePages/B2BScheduleMainPage";
import EditResume from "./pages/b2bCandidate/cv-optimizer/EditResume";
import ViewReport from "./pages/b2bCandidate/cv-optimizer/ViewReport";

const userDetail = Utils.getUserDetail();

// ─── Shared auth routes (password reset, email verify) ───────────────────────
// Reused across all logged-in role route trees so users can still access
// these flows after login (e.g., first-time password set via invite link).

const sharedAuthRoutes = (
  <>
    <Route path="/newPassword/:id" element={<NewPassword />} />
    <Route path="/verifyEmail/:id" element={<MailVerified />} />
  </>
);

// ─── Role route trees ─────────────────────────────────────────────────────────

function CandidateRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/login" element={<Navigate to="/dashboard" />} />
      <Route path="/signup" element={<Navigate to="/dashboard" />} />
      {sharedAuthRoutes}
      <Route path="/userLock" element={<UserLock />} />
      <Route path="/dashboard" element={<CandidateDashboard />} />
      <Route path="/settings" element={<Settings userRole="candidate" />} />
      <Route path="/credits" element={<CreditsPage userRole="candidate" />} />
      <Route path="/candidateOnboarding" element={<CandidateOnboarding />} />
      <Route path="/underConstruction" element={<UnderConstruction />} />
      <Route path="/preparation" element={<Preparation />} />
      <Route
        path="/prepareGuide/:jobGuideIdentifier"
        element={<LearnOrPractice />}
      />
      <Route path="/practiceGuide/:jobGuideIdentifier" element={<Practice />} />
      <Route path="/test" element={<Test />} />
      <Route path="/mock-interview" element={<MockInterview />} />
      <Route path="/schedule-mock-interview" element={<ScheduleMainPage />} />
      {/* <Route path="cv-optimizer" element={<CVOptimizer />} /> */}
      <Route path="/cv-optimizer" element={<B2BCVOptimizer />} />
      <Route path="/editResume" element={<EditResume />} />
      <Route path="/viewReport" element={<ViewReport />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/create-jd" element={<JdCreationPage />} />
      <Route path="/mock-interview-create-jd" element={<MockCreateNew />} />
      <Route path="/viewGuide/:jobGuideIdentifier" element={<ViewGuide />} />
      <Route path="/savedraft" element={<SaveDraftGuide />} />
    </Routes>
  );
}

function GlobalAdminRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/" element={<Navigate to="/global-admin/dashboard" />} />
      <Route
        path="/login"
        element={<Navigate to="/global-admin/dashboard" />}
      />
      {sharedAuthRoutes}
      {/* TODO: Add staff-specific routes here */}
      {/* <Route path="/staff/dashboard" element={<StaffDashboard />} /> */}
      <Route path="/underConstruction" element={<UnderConstruction />} />
      <Route path="/global-admin/dashboard" element={<UnderConstruction />} />
      <Route
        path="/credits"
        element={<CreditsPage userRole={ROLES.global_admin} />}
      />
      <Route
        path="/global-admin/credits"
        element={<CreditsPage userRole={ROLES.global_admin} />}
      />
      <Route
        path="/settings"
        element={<Settings userRole={ROLES.global_admin} />}
      />
    </Routes>
  );
}

function OrgAdminRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/" element={<Navigate to="/org-admin/dashboard" />} />
      <Route path="/login" element={<Navigate to="/org-admin/dashboard" />} />
      {sharedAuthRoutes}
      {/* TODO: Add org-admin-specific routes here */}
      {/* <Route path="/org-admin/dashboard" element={<OrgAdminDashboard />} /> */}
      <Route path="/underConstruction" element={<UnderConstruction />} />
      {/* <Route path="/org-admin/dashboard" element={<UnderConstruction />} /> */}
      <Route path="/org-admin/dashboard" element={<OrgAdminDashboard />} />
      <Route path="/org-admin/jobs" element={<OrgAdminJobs />} />
      <Route path="/org-admin/batches" element={<OrgAdminStudents />} />
      <Route
        path="/org-admin/preparation-guides"
        element={<OrgAdminPrepGuides />}
      />
      <Route path="/org-admin/create-jd" element={<OrgAdminJdCreation />} />
      <Route
        path="org-admin/prepareGuide/:jobGuideIdentifier"
        element={<OrgAdminViewGuide />}
      />
      <Route
        path="/org-admin/viewGuide/:jobGuideIdentifier"
        element={<OrgAdminViewGuideMaster />}
      />
      <Route
        path="/org-admin/practiceGuide/:jobGuideIdentifier"
        element={<OrgAdminPractice />}
      />
      <Route path="/org-admin/batches/:id" element={<OrgAdminViewBatch />} />
      <Route path="/org-admin/batches/bulk" element={<OrgAdminBulkDetails />} />
      <Route
        path="/org-admin/mock-interviews"
        element={<OrgAdminMockInterview />}
      />
      <Route
        path="/org-admin/mock-interview-create-jd"
        element={<OrgAdminMockCreateNew />}
      />
      <Route
        path="/org-admin/manage-mock-interview"
        element={<OrgAdminManageInterview />}
      />
      <Route
        path="/credits"
        element={<CreditsPage userRole={ROLES.org_admin} />}
      />
      <Route
        path="/org-admin/credits"
        element={<CreditsPage userRole={ROLES.org_admin} />}
      />
      <Route
        path="/settings"
        element={<Settings userRole={ROLES.org_admin} />}
      />
    </Routes>
  );
}

function B2BStudentRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/" element={<Navigate to="/b2b-candidate/dashboard" />} />
      <Route
        path="/login"
        element={<Navigate to="/b2b-candidate/dashboard" />}
      />
      <Route
        path="/signup"
        element={<Navigate to="/b2b-candidate/dashboard" />}
      />
      <Route
        path="/dashboard"
        element={<Navigate to="/b2b-candidate/dashboard" />}
      />
      {sharedAuthRoutes}
      <Route path="/userLock" element={<UserLock />} />
      <Route
        path="/b2b-candidate/dashboard"
        element={<B2BCandidateDashboard />}
      />
      <Route
        path="/settings"
        element={<Settings userRole={ROLES.b2b_candidate} />}
      />
      <Route path="/candidateOnboarding" element={<CandidateOnboarding />} />
      <Route path="/underConstruction" element={<UnderConstruction />} />
      <Route path="/b2b-candidate/preparation" element={<B2BPreparation />} />
      <Route path="/b2b-candidate/test" element={<B2BTest />} />
      <Route
        path="/b2b-candidate/mock-interview"
        element={<B2BMockInterview />}
      />
      <Route
        path="/b2b-candidate/schedule-mock-interview"
        element={<B2BScheduleMainPage />}
      />
      <Route path="/cv-optimizer" element={<B2BCVOptimizer />} />
      <Route path="/editResume" element={<EditResume />} />
      <Route path="/viewReport" element={<ViewReport />} />

      {/* <Route path="/b2b-candidate/insights" element={<B2BInsights />} /> */}
      {/* <Route path="/b2b-candidate/create-jd" element={<JdCreationPage />} />
      <Route
        path="/b2b-candidate/mock-interview-create-jd"
        element={<MockCreateNew />}
      />
      <Route path="/b2b-candidate/savedraft" element={<SaveDraftGuide />} />
       */}
      <Route path="/b2b-candidate/jobs" element={<B2BJobs />} />
      <Route
        path="/b2b-candidate/prepareGuide/:jobGuideIdentifier"
        element={<B2BCandLearnOrPractice />}
      />
      <Route
        path="/b2b-candidate/practiceGuide/:jobGuideIdentifier"
        element={<B2BPractice />}
      />
      <Route
        path="/b2b-candidate/viewGuide/:jobGuideIdentifier"
        element={<B2BCandViewGuide />}
      />
    </Routes>
  );
}

// ─── Unauthenticated routes ───────────────────────────────────────────────────

function UnauthenticatedRoutes() {
  function DynamicLoginPage() {
    if (window.location.pathname !== "/") {
      const redirectUrl = `/login?redirect=${encodeURIComponent(
        window.location.pathname + window.location.search,
      )}`;
      window.location.replace(redirectUrl);
      return null;
    }
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/verifyEmail" element={<MailVerified />} />
      <Route path="/verifyEmail/:id" element={<MailVerified />} />
      <Route path="/checkMail" element={<CheckMail />} />
      <Route path="/newPassword" element={<NewPassword />} />
      <Route path="/newPassword/:id" element={<NewPassword />} />
      <Route path="*" element={<DynamicLoginPage />} />
    </Routes>
  );
}

// ─── Role resolver ────────────────────────────────────────────────────────────

function RoleBasedRoutes() {
  if (!userDetail || !userDetail.userRole) {
    return <UnauthenticatedRoutes />;
  }
  if (userDetail?.userPasswordRequired) {
    return (
      <Routes>
        <Route path="/password-required" element={<ForcePassRequired />} />

        {/* Redirect all other routes */}
        <Route
          path="*"
          element={<Navigate to="/password-required" replace />}
        />
      </Routes>
    );
  }

  switch (userDetail.userRole) {
    case ROLES.candidate:
      return <CandidateRoutes />;
    case ROLES.global_admin:
      return <GlobalAdminRoutes />;
    case ROLES.org_admin:
      return <OrgAdminRoutes />;
    case ROLES.b2b_candidate:
      return <B2BStudentRoutes />;
    default:
      // Unknown role — send to login to prevent a blank screen
      return <UnauthenticatedRoutes />;
  }
}

// ─── App ──────────────────────────────────────────────────────────────────────

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Inter",
        },
      }}
    >
      <HelmetProvider>
        <BrowserRouter>
          <RoleBasedRoutes />
        </BrowserRouter>
      </HelmetProvider>
    </ConfigProvider>
  );
}

export default App;
